const testimonials = [
  {
    name: '陳經理',
    company: '健康品牌創辦人',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businessman%20portrait%20headshot%20confident%20smiling%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%2040s%20male&width=120&height=120&seq=avatar-01&orientation=squarish',
    quote: '康永生技的服務讓我們從零開始打造自己的保健品牌，從配方研發到包裝設計一路協助，上市時程比預期提前了兩個月。',
    rating: 5,
  },
  {
    name: '林小姐',
    company: '保健品品牌商主理人',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20businesswoman%20portrait%20headshot%20warm%20smiling%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%2035s%20female&width=120&height=120&seq=avatar-02&orientation=squarish',
    quote: '與康永合作已超過三年，每次的品質都非常穩定，對於法規文件的準備也非常專業，讓我們在拓展海外市場時省去很多麻煩。',
    rating: 5,
  },
  {
    name: '李先生',
    company: '連鎖藥局採購',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20executive%20manager%20portrait%20headshot%20serious%20confident%2C%20clean%20white%20background%2C%20formal%20business%20attire%2C%2050s%20male&width=120&height=120&seq=avatar-03&orientation=squarish',
    quote: '康永的研發團隊非常用心，能夠理解我們的市場定位並提出最合適的配方建議，是真正把客戶需求放在第一位的代工夥伴。',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-4 border border-green-200">
            客戶見證
          </span>
          <h2 className="text-[#1a2e1a] font-bold mb-4">
            他們都選擇康永生技
          </h2>
          <p className="text-gray-500 text-[1.0625rem] leading-[1.75] max-w-2xl mx-auto">
            超過 250 個品牌的信任，是我們最好的口碑
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="bg-[#f7faf7] rounded-2xl p-7 border border-gray-100 hover:border-green-200 transition-all duration-300"
            >
              {/* Stars */}
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#FFCA28] text-base" />
                ))}
              </div>
              {/* Quote */}
              <p className="text-gray-600 text-[0.9375rem] leading-[1.75] mb-6 italic">
                &ldquo;{t.quote}&rdquo;
              </p>
              {/* Author */}
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                </div>
                <div>
                  <p className="text-[#1a2e1a] font-semibold text-[0.9375rem]">{t.name}</p>
                  <p className="text-gray-400 text-[0.8125rem]">{t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
